import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { getCookies, scopesCookieKey } from "../../API/cookies";

/**
 * Component for conditionally displaying a UI element based on user permissions
 *
 */

const PermissionedDisplay = React.forwardRef(({ children, permission, ...props }, ref) => {
  const scope = getCookies(scopesCookieKey);
  const permissions = scope ? scope.split(" ") : [];
  const [allowed, setAllowed] = useState(false);
  permissions.push(null);

  useEffect(() => {
    if (!permission) setAllowed(true);
    else if (typeof permission === "string") setAllowed(permissions.includes(permission));
    else if (Array.isArray(permission))
      setAllowed(permission.every((p) => permissions.includes(p)));
    else setAllowed(false);
  }, [permission]);

  if (ref) return allowed ? React.cloneElement(React.Children.only(children), { ref }) : props.else;
  return allowed ? children : props.else;
});

PermissionedDisplay.propTypes = {
  children: PropTypes.node.isRequired,
  permission: PropTypes.any,
  else: PropTypes.node,
};

PermissionedDisplay.defaultProps = {
  permission: null,
  else: null,
};

export default PermissionedDisplay;
